// @ts-nocheck
import estimateAPI from './api';
import TYPES from './types';

export const getEstimate = async (data, successCB, errorCB) => {
    const handleError = (error) => {
        if (errorCB && typeof errorCB === 'function') {
            errorCB(error);
        } else {
            throw new Error(`Error loading estimate: ${JSON.stringify(error)}`);
        }
    };

    try {
        const response = await estimateAPI.getEstimate({ data });

        if (response && response.data.payload) {
            if (successCB && typeof successCB === 'function') {
                successCB(response.data.payload);
            }

            return response.data.payload;
        }

        handleError({ status: response.data.status, type: 'API_ERROR', msg: response?.message ?? response });
    } catch (error) {
        handleError({ type: 'API_ERROR', msg: error });
    }
};

export const loadEstimate = (dispatch) => async (data, errContext, successCB, errorCB) => {
    const onLoadSuccess = (estimate) => {
        dispatch({
            type: TYPES.SET_ESTIMATES,
            payload: estimate,
        });
        if (successCB && typeof successCB === 'function') successCB(estimate);
        dispatch({ type: TYPES.SET_ESTIMATE_LOADED });
    };

    const onLoadError = ({ status, type, msg }) => {
        errContext.DISPATCH({ type, payload: { status, alert: msg } });

        if (errorCB && typeof errorCB === 'function') {
            errorCB({ status, type, msg });
        }
    };

    dispatch({ type: TYPES.SET_ESTIMATE_LOADING });

    await getEstimate(data, onLoadSuccess, onLoadError);
};